import React from 'react';
import './App.css';

import Header from './components/Header/Header';
import Carousel from './components/Carousel/Carousel';
import Services from './components/Services/Services';
import About from './components/About/About';
import Map from './components/Map/Map';
import Promotions from './components/Promotions/Promotions';
import Reviews from './components/Reviews/Reviews';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Carousel />
        <Services />
        <Promotions />
        <About />
        <Reviews />
        <Map />
      </main>
      <FloatingButtons />
    </div>
  );
}

export default App;